<template>
	<div v-if="init" class="apply-state" :style="nextStyle">
		<div class="line-apply">
            <div class="num-tag" :class="{'num-tag-fire':state === 'ing'}">
                <span>{{this.stage}}</span>
                <span v-if="state === 'ing'">火热进行中</span>
                <span v-if="state === 'start'">即将开始</span>
                <span v-if="state === 'end'">已结束</span>
            </div>

			<div @click.stop="clickNext()" class="state">
				<h4>{{nextText}}</h4>
			</div>
		</div>

        <div class="product-info">
            <div class="text">
                <div class="name text-overflow">{{title}}</div>
                <div class="desc text-overflow" v-html="try_subtitle"></div>
            </div>
            <div class="price">
                <div class="num">
                    <span class="yang">￥</span><span class="sale">0</span><span class="del">￥{{price}}</span>
                </div>
                <div class="join-num">
                    共{{totalNum}}份{{applyNum}}人申请
                </div>
            </div>
        </div>
	</div>
</template>
<script>

	import { mapState } from 'vuex'

	export default {
		name: 'apply-state-component',
		props: ['try_subtitle', 'title', 'nextText', 'nextTid', 'nextStyle'],
		data() {
			return {
				nextExist: -1,
			}
		},
		computed: {
			...mapState({
				init: 'init',
				state: 'applyState',
				count: 'count',
				sqrCount: 'sqrCount',
				stage: 'stage',
				price: 'price',
				report_url: 'report_url',
				selected: 'selected',
				detailId: 'detailId',
				tid: 'tid',
				totalNum: 'totalNum',
				applyNum: 'applyNum',
			})
		},
		watch: {
		},
		created() {
		},

		components: {

		},
		methods: {
			clickNext() {
				if (this.nextTid > 0) {
					this.$router.push({
						path: '/detail/' + this.nextTid
					})
				}
			},
		}
	}
</script>

<style scoped lang="scss">
	.text-overflow {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	.apply-state {
		position: relative;
		z-index: 2;
		width: 6.79rem;
		height: 1.57rem;
		margin: .28rem auto 0;
		color: #595959;
		background: url('~@/assets/detail/detail-product-title-bg-next.png') top center/cover no-repeat;
		background-size: 100% 100%;
        .state {
            width: 2.5rem;
            height: .38rem;
            line-height: .38rem;
            text-align: center;
            font-size: 0.32rem;
            color: #FFFFFF;
            margin-left: .1rem;
            h4 {
                color: #000;
                font-weight: normal;
            }
        }
	}

	.line-apply {
		display: flex;
		align-items: center;
        height: .54rem;
		padding-left: .1rem;
        .num-tag{
            position: relative;
            width: 2.2rem;
            height: .38rem;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            background-color: #B11C16;
            border-radius: .19rem;
            padding: 0 .1rem;
            font-size: .19rem;
            text-align: center;
            span{
                &:first-child{
                    padding-right: .1rem;
                }
            }
        }
        .num-tag-fire{
            text-align: left;
            justify-content: start;
            &::after{
                content: '';
                display: block;
                position: absolute;
                right: -.1rem;
                top: -.12rem;
                width: .38rem;
                height: .5rem;
                background-image: url("~@/assets/detail/fire.png");
                background-size: cover;
            }
        }
	}

    .product-info{
        //height: 1.05rem;
        display: flex;
        padding-top: .1rem;
        justify-content: space-between;
        .text{
            width: 5.05rem;
            padding-left: .2rem;
            .name{
                font-size: .32rem;
                color: black;
                font-weight: bold;
                line-height: .5rem;
            }
            .desc{
                font-size: .19rem;
                color: #595959;
            }
        }
        .price{
            width: 1.6rem;
            padding-right: .25rem;
            margin-top: -.08rem;
            .num{
                .yang, .sale{
                    color: #b11c16;
                }
                .yang{
                    font-size: .18rem;
                }
                .sale{
                    font-size: .46rem;
                    font-weight: bold;
                }
                .del{
                    font-size: .17rem;
                    padding-left: .1rem;
                    color: #6d6d6d;
                    text-decoration: line-through;
                }
            }
            .join-num{
                font-size: .17rem;
                color: #6d6d6d;
            }
        }
    }

</style>
